import { useState, useEffect, useRef, SetStateAction } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useAuth } from '../providers/auth';
import api from "../services/api";
import { useToast } from '../context/ToastContext';
import { ALERTAS } from '../utilities/constantes';
import { useForm } from 'react-hook-form';
import { SCCalendar, SCCheckbox, SCDialog, SCDropdown, SCFieldset } from '../components';
import AjudaFormTela from './AjudaFormTela';
import { CheckboxChangeParams } from 'primereact/checkbox';
import Loading from '../components/Loading';
import FaturaCartaoQuitadaDetalhes from './FaturaCartaoQuitadaDetalhes';
import util from '../utilities/util';
import IApagar from '../interfaces/IApagar';

const FaturaCartaoQuitada = () => {
  const toast = useToast();
  const { periodoSelecionado, usuario } = useAuth();
  const tarefa = 'FaturaCartao';

  let emptyContaAPagar: IApagar = {
    ApagarId: undefined,
    AtualizacaoData: new Date(''),
    AtualizacaoHora: new Date(''),
    AtualizacaoOperador: '',
    CartoesId: null,
    CentroCustoId: null,
    ContaDescontoId: null,
    ContaJurosPagamento: null,
    ContaMultaPagamento: null,
    ContaValorId: null,
    CredorId: '',
    DataBomPara: null,
    DataPagamento: null,
    DataProgramada: null,
    DataVencimento: null,
    EmpresaId: periodoSelecionado?.EmpresaId,
    FonteId: null,
    FormasPagamentoId: '',
    LancamentoData: new Date(''),
    LancamentoHora: new Date(''),
    LancamentoOperador: '',
    NumeroDocumento: '',
    NumeroDocumentoPagamento: '',
    Observacao: '',
    Referente: '',
    Valor: 0,
    ValorDesconto: 0,
    ValorDescontoPagamento: 0,
    ValorDescontoProgramado: 0,
    ValorJurosPagamento: 0,
    ValorJurosProgramado: 0,
    ValorMultaPagamento: 0,
    ValorMultaProgramado: 0,
    ValorPagamento: 0,
    ValorProgramado: 0,
    DataInicialVencimento: null,
    DataFinalVencimento: null,
    DataInicialPagamento: null,
    DataFinalPagamento: null,
    Nome: '',
    FlgMeuCaixa: 0,
    CodigosEstornoId: undefined,
    Status: 'TODOS',
    CartaoInstitucionalId: null,
    CartaoInstitucional: false,
    FaturaCartao: false,
  };

  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [aPagar, setAPagar] = useState<any>([]);
  const [usuarios, setUsuarios] = useState<any>([]);
  const [valorTotalSelecionado, setValorTotalSelecionado] = useState(0);
  const [loading, setLoading] = useState(false)
  const [disableEstorno, setDisableEstorno] = useState<boolean>(true)
  const [faturaCartaoDetalhesDialog, setFaturaCartaoDetalhesDialog] = useState<boolean>(false);
  const [contaApagar, setContaApagar] = useState<IApagar>(emptyContaAPagar);

  const methods = useForm();
  const { control, watch, getValues, setValue } = methods;

  const watchUsuario = watch('UsuarioId')
  const watchDataI = watch('DataInicial')
  const watchDataF = watch('DataFinal')

  const load = async () => {
    setLoading(true)
    const result = await api.get('/usuario/listaUsuario');

    if (result.data) {
      setUsuarios(result.data);
    } else {
      setUsuarios([])
    }

    const formattedDataI = watchDataI ? new Date(watchDataI).toISOString().split('T')[0] : null;
    const formattedDataF = watchDataF ? new Date(watchDataF).toISOString().split('T')[0] : null;

    const result2 = await api.get('/apagar/listLiquidaFatura', {
      params: {
        DataILiquida: formattedDataI,
        DataFLiquida: formattedDataF,
        Operador: watchUsuario,
        FaturasQuitadas: true
      }
    })
    if (result2.data) {
      const uniqueItems: any = [];
      const seenIds = new Set();

      result2.data.forEach((item: any) => {
        if (!seenIds.has(item.LiquidaFaturaId)) {
          seenIds.add(item.LiquidaFaturaId);
          uniqueItems.push(item);
        }
      });

      setAPagar(uniqueItems);
      // setAPagar(result2.data)
    } else {
      setAPagar([])
    }

    setLoading(false)
  };

  useEffect(() => {
    load();
  }, []);

  const handleCheckboxChange = (rowData: any, checked: boolean) => {
    const updatedAPagar = aPagar.map((item: any) => {
      if (item.ApagarId === rowData.ApagarId) {
        return { ...item, Selecionado: checked ? 1 : 0 };
      }
      return { ...item, Selecionado: 0, Disabled: checked };
    });

    setAPagar(updatedAPagar);
    const algumSelecionado = updatedAPagar.some((item: any) => item.Selecionado === 1);
    setDisableEstorno(!algumSelecionado);
    atualizarValorTotalSelecionado(updatedAPagar);
  };

  const onSubmit = async () => {
    try {
      let valorTotal = 0;
      const hours = String(new Date().getHours()).padStart(2, '0');
      const minutes = String(new Date().getMinutes()).padStart(2, '0');
      const formattedTime = `${hours}:${minutes}`;

      aPagar.forEach(async (item: any) => {
        if (item.Selecionado === 1) {
          console.log(item)
          const updateItensApagar = {
            LiquidaFaturaIdAnterior: item.LiquidaFaturaId,
            LiquidaFaturaId: 0,
            FaturaCartao: false,
          }
          const updateItemLiquidaFatura = {
            LiquidaFaturaId: item.LiquidaFaturaId,
            Excluido: true,
            ExcluidoData: new Date(),
            ExcluidoHora: formattedTime,
            ExcluidoOperador: usuario?.Apelido,
          }

          await api.put('/apagar/estornoFatura', updateItensApagar);
          await api.put('/liquidaFatura/estornoFatura', updateItemLiquidaFatura);
        }
      });

      toast.showToast({ severity: 'success', summary: 'Atenção', detail: ALERTAS.registroGravado });
      load()

    } catch (e: any) {
      toast.showToast({ severity: 'error', summary: 'Erro', detail: e?.response?.data?.error });
    }
  };

  const atualizarValorTotalSelecionado = (dados: any[]) => {
    const soma = dados
      .filter(item => item.Selecionado === 1)
      .reduce((acc, item) => acc + (item.LiquidaValor || 0), 0);
    setValorTotalSelecionado(soma);
  };

  useEffect(() => {
    atualizarValorTotalSelecionado(aPagar);
  }, [aPagar]);

  const detalhes = (conta: any) => {
    setFaturaCartaoDetalhesDialog(true);

    conta.DataVencimento = conta.DataVencimento ? new Date(conta.DataVencimento) : null;
    conta.DataProgramada = conta.DataProgramada ? new Date(conta.DataProgramada) : null;
    conta.DataPagamento = conta.DataPagamento ? new Date(conta.DataPagamento) : null;
    conta.DataBomPara = conta.DataBomPara ? new Date(conta.DataBomPara) : null;

    setContaApagar(conta);
  };

  const hideDialog = () => {
    setFaturaCartaoDetalhesDialog(false);
  };

  return (
    <div className="grid crud-demo">
      <div className="col-12">
        <div className="card">
          <div className='flex justify-content-center align-items-center p-2 border-round-top-md text-white' style={{ backgroundColor: '#0772B3' }}>
            <h5 className="m-0 flex flex-1 align-items-center justify-content-center">Fatura de Cartão - Quitadas</h5>
            <AjudaFormTela tarefa={tarefa} campo='' />
          </div>
          <SCFieldset legend='Filtros' className='col-12 mt-2 pt-0'>
            <div className='grid'>
              <div className="col-12 md:col-2">
                <SCCalendar
                  control={control}
                  label='Data Liquidação Inicial'
                  name='DataInicial'
                  dateFormat='dd/mm/yy'
                  mask='99/99/9999'
                  placeholder='Data Inicial'
                />
              </div>

              <div className="col-12 md:col-2">
                <SCCalendar
                  control={control}
                  label='Data Liquidação Final'
                  name='DataFinal'
                  dateFormat='dd/mm/yy'
                  mask='99/99/9999'
                  placeholder='Data Final'
                />
              </div>
              <div className="col-12 md:col-6">
                <SCDropdown
                  name="UsuarioId"
                  label='Operadores'
                  options={usuarios}
                  optionLabel='Apelido'
                  optionValue='Apelido'
                  value={watchUsuario}
                  onChange={(e) => setValue('UsuarioId', e.target.value)}
                  style={{ width: '100%' }}
                />
              </div>
              <div className='col-12 md:col-2 flex align-items-end'>
                <Button label='Pesquisar' icon="pi pi-search" className="p-button-info p-button-outlined" type='button' onClick={load} />
              </div>
            </div>
          </SCFieldset>

          {loading ? <Loading /> : (
            <DataTable
              size='small'
              stripedRows
              value={aPagar}
              dataKey="ApagarId"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="{first} a {last} de {totalRecords}"
              emptyMessage="Nenhum registro encontrado."
              header={null}
              responsiveLayout="scroll"
            // footer={footer}
            >
              <Column field="LiquidaFaturaId" header="Fatura" sortable headerStyle={{ width: '10%' }} ></Column>
              {/* <Column field="NumeroDocumento" header="Nº Documento" headerStyle={{ width: '15%' }} ></Column> */}
              <Column field="LancamentoData" header="Data Liquidação" body={(rowData: any) => {
                if (rowData.LancamentoDataString) {
                  return (
                    <span>{rowData.LancamentoDataString}</span>
                  );
                }
                return null;
              }} style={{ width: '16%' }} />
              <Column field="LancamentoHora" header="Hora Liquidação" headerStyle={{ width: '20%' }} ></Column>
              <Column field="LancamentoOperador" header="Operador da Liquidação" sortable headerStyle={{ width: '20%' }} ></Column>

              <Column field="LiquidaValor" header="Valor" align='center' sortable body={(rowData: any) => {
                return (
                  <span>R$ {rowData.LiquidaValor?.toFixed(2).replace('.', ',')}</span>
                );
              }} style={{ width: '15%' }}
              />

              <Column align='center' body={(rowData: any) => {
                return (
                  <div className="actions flex align-items-center justify-content-between">
                    <Button label='Ver Itens' className="p-button-warning" onClick={() => { detalhes(rowData) }} />
                  </div>
                );
              }} headerStyle={{ width: '10%' }}
              />

              <Column
                body={(rowData: any) => (
                  <div className="col-12 flex justify-content-center">
                    <SCCheckbox
                      checked={rowData.Selecionado === 1}
                      disabled={rowData.Disabled}
                      onChange={(e: CheckboxChangeParams) => handleCheckboxChange(rowData, e.checked)}
                      id={rowData.ApagarId}
                      name="Selecionado"
                    />
                  </div>
                )}
                alignHeader='center'
                align='center'
              />
            </DataTable>
          )}

          <div className='grid flex justify-content-center'>
            <div className='col-12 md:col-10 pt-4 flex justify-content-center align-items-center'></div>
            <div className='col-12 md:col-2 flex justify-content-end mt-2 '>
              <Button label='Estornar Fatura' icon="pi pi-plus-o" className="p-button-danger" type='button' style={{ width: '100%' }} onClick={onSubmit} disabled={disableEstorno} />
            </div>
          </div>

          <SCDialog maximized={!util.isDesktop()} visible={faturaCartaoDetalhesDialog} style={{ width: util.isDesktop() ? '80%' : '100%' }} closable={!util.isDesktop()}
            header={'Detalhes da Fatura'}
            modal className="p-fluid" onHide={hideDialog}
          >
            <FaturaCartaoQuitadaDetalhes
              LiquidaFaturaId={contaApagar.LiquidaFaturaId}
              setFaturaCartaoQuitadaDetalhes={setFaturaCartaoDetalhesDialog}
              reload={load}
            />
          </SCDialog>
        </div>
      </div>
    </div>

  );
};

export default FaturaCartaoQuitada;